import script from "./IpOSExecutadaViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./IpOSExecutadaViewPage.vue?vue&type=script&setup=true&lang=js"

import "./IpOSExecutadaViewPage.vue?vue&type=style&index=0&id=302984d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-302984d8"]])

export default __exports__